// UK counties for The Hangar Global form, grouped by nation.
export const ukcounties = [
  {
    region: "England",
    counties: [
      "Bedfordshire",
      "Berkshire",
      "Bristol",
      "Buckinghamshire",
      "Cambridgeshire",
      "Cheshire",
      "City of London",
      "Cornwall",
      "Cumbria",
      "Derbyshire",
      "Devon",
      "Dorset",
      "Durham",
      "East Riding of Yorkshire",
      "East Sussex",
      "Essex",
      "Gloucestershire",
      "Greater London",
      "Greater Manchester",
      "Hampshire",
      "Herefordshire",
      "Hertfordshire",
      "Isle of Wight",
      "Kent",
      "Lancashire",
      "Leicestershire",
      "Lincolnshire",
      "Merseyside",
      "Norfolk",
      "North Yorkshire",
      "Northamptonshire",
      "Northumberland",
      "Nottinghamshire",
      "Oxfordshire",
      "Rutland",
      "Shropshire",
      "Somerset",
      "South Yorkshire",
      "Staffordshire",
      "Suffolk",
      "Surrey",
      "Tyne and Wear",
      "Warwickshire",
      "West Midlands",
      "West Sussex",
      "West Yorkshire",
      "Wiltshire",
      "Worcestershire",
    ],
  },
  {
    region: "Scotland",
    counties: [
      "Aberdeen City",
      "Aberdeenshire",
      "Angus",
      "Argyll and Bute",
      "Clackmannanshire",
      "Dumfries and Galloway",
      "Dundee City",
      "East Ayrshire",
      "East Dunbartonshire",
      "East Lothian",
      "East Renfrewshire",
      "Edinburgh (City of)",
      "Falkirk",
      "Fife",
      "Glasgow City",
      "Highland",
      "Inverclyde",
      "Midlothian",
      "Moray",
      "Na h-Eileanan Siar (Western Isles)",
      "North Ayrshire",
      "North Lanarkshire",
      "Orkney Islands",
      "Perth and Kinross",
      "Renfrewshire",
      "Scottish Borders",
      "Shetland Islands",
      "South Ayrshire",
      "South Lanarkshire",
      "Stirling",
      "West Dunbartonshire",
      "West Lothian",
    ],
  },
  {
    region: "Wales",
    counties: [
      "Blaenau Gwent",
      "Bridgend",
      "Caerphilly",
      "Cardiff",
      "Carmarthenshire",
      "Ceredigion",
      "Conwy",
      "Denbighshire",
      "Flintshire",
      "Gwynedd",
      "Isle of Anglesey",
      "Merthyr Tydfil",
      "Monmouthshire",
      "Neath Port Talbot",
      "Newport",
      "Pembrokeshire",
      "Powys",
      "Rhondda Cynon Taf",
      "Swansea",
      "Torfaen",
      "Vale of Glamorgan",
      "Wrexham",
    ],
  },
  {
    region: "Northern Ireland",
    counties: [
      "Antrim",
      "Armagh",
      "Down",
      "Fermanagh",
      "Londonderry",
      "Tyrone",
      "Belfast",
      "Derry",
    ],
  },
];
